import type { ServiceTypeConfig } from '../../../domain/types/configs/company/ServiceTypeConfig';

export const serviceTypeConfig: ServiceTypeConfig = {
  serviceType: [
    {
      value: "CFS/CFS",
      label: "Container Freight Station to Container Freight Station",
      visible: true
    },
    {
      value: "CFS/CY",
      label: "Container Freight Station to Container Yard",
      visible: true
    },
    {
      label: "Container Freight Station to Door",
      value: "CFS/DOOR",
      visible: true
    },
    {
      value: "CY/CFS",
      label: "Container Yard to Container Freight Station",
      visible: true
    },
    {
      label: "Container Yard to Container yard",
      value: "CY/CY",
      visible: true
    },
    {
      value: "CY/DOOR",
      label: "Container Yard to Door",
      visible: true
    },
    {
      label: "Door to Container Freight Station",
      value: "DOOR/CFS",
      visible: true
    },
    {
      value: "DOOR/CY",
      label: "Door to Container Yard",
      visible: true
    },
    {
      value: "DOOR/DOOR",
      label: "Door to Door",
      visible: true
    },
    {
      value: "DOOR/PORT",
      label: "Door to Port",
      visible: true
    },
    {
      value: "PORT/DOOR",
      label: "Port to Door",
      visible: true
    },
    {
      value: "PORT/PORT",
      label: "Port to Port",
      visible: true
    }
  ]
}; 